import { render, staticRenderFns } from "./customerWithdrawal.vue?vue&type=template&id=397ad161&scoped=true&"
import script from "./customerWithdrawal.vue?vue&type=script&lang=js&"
export * from "./customerWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./customerWithdrawal.vue?vue&type=style&index=0&id=397ad161&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ad161",
  null
  
)

export default component.exports